/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_IllustrativeInputs */

const en_cap_illustrative = /** @type {(inputs: Cap_IllustrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative example`)
};

const lv_cap_illustrative = /** @type {(inputs: Cap_IllustrativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustratīvs piemērs`)
};

/**
* | output |
* | --- |
* | "Illustrative example" |
*
* @param {Cap_IllustrativeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_illustrative = /** @type {((inputs?: Cap_IllustrativeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_IllustrativeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_illustrative(inputs)
	return en_cap_illustrative(inputs)
});